<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Edit Agent</h3>
  </div>
  <div class="modal-content">
    <app-bot-editor [bot]="data!" [hideButtons]="true" (formValid)="updateFormValid($event)" (cancelCallback)="close()" (botUpdated)="save($event)"></app-bot-editor>
  </div>
  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-end">
      <button class="action-button" mat-raised-button color="accent" (click)="triggerSave()" [disabled]="!formValid">Save</button>
      <button class="action-button" mat-stroked-button (click)="close()">Cancel</button>
    </div>
  </div>
</div>
